import { ArrowDownLarge, ArrowUpLarge } from '@pets-ui/icons'
import { type CSSProperties } from 'react'

interface CollapseIconProps {
  open: boolean
  color?: CSSProperties['color']
}

export const CollapseIcon = ({ open, color }: CollapseIconProps) => {
  return (
    <>
      {open ? <ArrowUpLarge color={color} /> : <ArrowDownLarge color={color} />}
    </>
  )
}
